import { render, staticRenderFns } from "./HotelUser.vue?vue&type=template&id=22f9ed26"
import script from "./HotelUser.vue?vue&type=script&lang=js"
export * from "./HotelUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports